import { render, staticRenderFns } from "./PDialogContent.vue?vue&type=template&id=2e2ce502"
import script from "./PDialogContent.vue?vue&type=script&lang=js"
export * from "./PDialogContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports